import React from 'react';
import './StatsSection.css';

function StatsSection({
  stats = [
    {
      number: '15',
      suffix: '+',
      label: 'Years of team-led preventive care'
    },
    {
      number: '200',
      suffix: '+',
      label: 'Executives and families in the circle'
    },
    {
      number: '8',
      suffix: '',
      label: 'Risk domains in the assessment'
    },
    {
      number: '24',
      suffix: 'h',
      label: 'Member line, day and night'
    }
  ]
}) {
  return (
    <section className="ttc-stats-section py-4">
      <div className="container">
        <div className="row g-4">
          {stats.map((item, index) => (
            // Changed col-12 col-sm-6 col-lg-3 to col-6 col-lg-3 for a 2x2 layout on mobile
            <div key={index} className="col-6 col-lg-3">
              <div className="ttc-stat-card pt-3 border-top">
                <div className="ttc-stat-number-wrapper mb-2">
                  <span className="ttc-stat-number">{item.number}</span>
                  {item.suffix && (
                    <span className="ttc-stat-suffix">{item.suffix}</span>
                  )}
                </div>
                <p className="ttc-stat-label mb-0">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StatsSection;